<template>
  <v-dialog
    v-model="dialog"
    :loading="loading"
    width="800"
  >
    <template #activator="{ attrs, on }">
      <v-btn
        v-bind="attrs"
        v-on="on"
        small
      >
        Ansvar
      </v-btn>
    </template>

    <v-card>
      <v-toolbar flat>
        <v-toolbar-title>
          Rediger rollens ansvar
        </v-toolbar-title>

        <v-spacer />

        <v-menu
          v-model="addMenu"
          offset-y
          left
          :min-width="500"
          :close-on-content-click="false"
        >
          <template #activator="{ attrs, on }">
            <v-btn small v-bind="attrs" v-on="on">
              Tilføj ansvar
              <v-icon right>
                mdi-plus
              </v-icon>
            </v-btn>
          </template>

          <v-card>
            <v-toolbar flat>
              <v-toolbar-title>
                Tilføj ansvar
              </v-toolbar-title>
            </v-toolbar>

            <v-card-text>
              <v-autocomplete
                v-model="newRoleResponsibilityId"
                :items="selectableResponsibilities"
                label="Vælg ansvar"
                outlined
                item-value="id"
                item-text="title"
                dense
              />
            </v-card-text>

            <v-card-actions>
              <v-spacer />

              <v-btn
                :loading="creating"
                @click="add"
              >
                Tilføj
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-menu>

      </v-toolbar>
      <v-data-table
        :items="roleResponsibilities"
        :headers="headers"
      >
        <template #[`item.validFrom`]="{ value }">
          {{ value | formatDateTime }}
        </template>
        <template #[`item.actions`]="{ item }">
          <v-btn small @click="remove(item.id)">
            <v-icon>
              mdi-delete-outline
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'RoleResponsibilitiesComponent',
  props: {
    role: {
      type: Object,
      required: true
    },
    responsibilities: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      dialog: false,
      loading: false,
      creating: false,
      deleting: false,
      roleResponsibilities: [],
      addMenu: false,
      newRoleResponsibilityId: null,
      headers: [
        {
          text: 'Navn',
          value: 'responsibility.title'
        },
        {
          text: 'Gyldig fra',
          value: 'validFrom',
          align: 'right',
          sortable: false
        },
        {
          text: 'Gyldig til',
          value: 'validTo',
          align: 'right',
          sortable: false
        },
        {
          text: 'Actions',
          value: 'actions',
          align: 'right'
        }
      ]
    }
  },
  computed: {
    selectableResponsibilities() {
      return this.responsibilities.map(responsibility => {
        return {
          ...responsibility,
          disabled: this.roleResponsibilities.some(rr => rr.responsibility.id === responsibility.id)
        }
      });
    }
  },
  methods: {
    getItems: async function() {
      this.loading = true;

      try {
        const { data } = await this.$api.get('role-responsibilities', {
          params: {
            roleId: this.role.id
          }
        });

        this.roleResponsibilities = data;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading = false;
      }
    },
    add: async function() {
      this.creating = true;

      const model = {
        roleId: this.role.id,
        responsibilityId: this.newRoleResponsibilityId
      };

      try {
        await this.$api.post('role-responsibilities', model);

        this.addMenu = false;
        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.creating = false;
      }
    },
    remove: async function(id) {
      if (!confirm('Er du sikker?')) return;

      this.deleting = true;

      try {
        await this.$api.delete('role-responsibilities/' + id);

        this.getItems();
      } catch (error) {
        console.error(error);
      } finally {
        this.deleting = false;
      }
    }
  },
  watch: {
    dialog(value) {
      if (value) {
        this.getItems();
      }
    }
  }
}
</script>